import React from 'react'
import './footer.css'
const Footer = () => {
  return (
    <footer className='footer'>
        Copyright &#169; 2024 Avani Gajallewar. All Rights Reserved
    </footer>
  )
}

export default Footer
